export const LIST_PAGE_SIZE_OPTIONS = [
  { value: 10, label: '10 条/页' },
  { value: 20, label: '20 条/页' },
  { value: 50, label: '50 条/页' },
]

export function totalPagesFor(total, pageSize) {
  const n = Number(total) || 0
  const size = Number(pageSize) || 10
  return Math.max(1, Math.ceil(n / size))
}

export function pageRowOffset(page, pageSize) {
  return (Math.max(1, Number(page) || 1) - 1) * (Number(pageSize) || 10)
}

export function slicePageRows(rows, page, pageSize) {
  const list = Array.isArray(rows) ? rows : []
  const start = pageRowOffset(page, pageSize)
  return list.slice(start, start + (Number(pageSize) || 10))
}

export function clampPage(page, total, pageSize) {
  const max = totalPagesFor(total, pageSize)
  const p = Number(page) || 1
  return Math.min(Math.max(1, p), max)
}
